import { Panel, Skeleton, Stack } from '@cast/design-system';

type BannerMetricPanelSkeletonProps = {
  minWidth: number;
};

/** Matches loaded banner metric: label + value + trend chip under the value. */
export const BannerMetricPanelSkeleton = ({
  minWidth,
}: BannerMetricPanelSkeletonProps) => (
  <Panel
    sx={{
      p: 16,
      flex: `1 1 ${minWidth}px`,
      minWidth,
    }}
  >
    <Stack gap={4}>
      <Skeleton variant="text" height={18} width="70%" />
      <Skeleton variant="rounded" height={28} width="55%" />
      <Skeleton variant="rounded" height={16} width={28} />
    </Stack>
  </Panel>
);
